/******
 * This file was generated by a Rake task.
 * Do not modify this file manually.
 * Add changes to the `VendorLink.ts` file.
 ******/
// oxlint-disable-next-line no-unused-vars
import dayjs, { Dayjs } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";
dayjs.extend(utc);
dayjs.extend(timezone);

import { VendorLink } from "./VendorLink";

import { Audit } from "./Audit";
import { Project } from "./Project";

export type integrationSource =
    | "user_upload"
    | "procore"
    | "procore_sandbox"
    | "autodesk_construction"
    | "cmic"
    | "primavera_p6"
    | "microsoft_project"
    | "asta_power_project"
    | "faker"
    | "api_upload";

export const integrationSourceValues = {
    user_upload: 0,
    procore: 1,
    procore_sandbox: 2,
    autodesk_construction: 3,
    cmic: 4,
    primavera_p6: 5,
    microsoft_project: 6,
    asta_power_project: 7,
    faker: 8,
    api_upload: 9,
};

export abstract class VendorLinkModel {
    id: number;
    createdAt: Dayjs;
    integrationSource: integrationSource;
    projectId: number;
    sourceData: any | null;
    sourceHash: string | null;
    updatedAt: Dayjs;
    vendorLinkableId: number;
    vendorLinkableType: string;
    audits: Audit[] | undefined;
    project: Project | null | undefined;
    _destroy: boolean | undefined;

    /* eslint-disable max-statements */
    constructor(
        id: number,
        createdAt: Dayjs,
        integrationSource: integrationSource,
        projectId: number,
        sourceData: any | null,
        sourceHash: string | null,
        updatedAt: Dayjs,
        vendorLinkableId: number,
        vendorLinkableType: string,
        audits: Audit[] | undefined,
        project: Project | null | undefined
    ) {
        this.id = id;
        this.createdAt = createdAt;
        this.integrationSource = integrationSource;
        this.projectId = projectId;
        this.sourceData = sourceData;
        this.sourceHash = sourceHash;
        this.updatedAt = updatedAt;
        this.vendorLinkableId = vendorLinkableId;
        this.vendorLinkableType = vendorLinkableType;
        this.audits = audits;
        this.project = project;
    }
    /* eslint-enable max-statements */

    // oxlint-disable-next-line complexity
    static fromApiObject(json: any, timezone: string): VendorLink {
        const newObject = new VendorLink(
            json["id"],
            dayjs(json["created_at"]).tz(timezone),
            json["integration_source"],
            json["project_id"],
            json["source_data"],
            json["source_hash"],
            dayjs(json["updated_at"]).tz(timezone),
            json["vendor_linkable_id"],
            json["vendor_linkable_type"],
            json["audits"]?.map((item: any) => Audit.fromApiObject(item, timezone)),
            json["project"] == null ? json["project"] : Project.fromApiObject(json["project"], timezone)
        );

        return newObject;
    }

    // oxlint-disable-next-line complexity
    toApiObject(visited = new Set<any>()): any {
        if (visited.has(this)) {
            // Return null, undefined, or primary key to break the cycle
            return undefined;
        }
        visited.add(this);

        return {
            id: this.id,
            created_at: this.createdAt,
            integration_source: this.integrationSource,
            project_id: this.projectId,
            source_data: this.sourceData,
            source_hash: this.sourceHash,
            updated_at: this.updatedAt,
            vendor_linkable_id: this.vendorLinkableId,
            vendor_linkable_type: this.vendorLinkableType,
            audits: this.audits?.map((item) => item.toApiObject(visited)).filter((item) => item !== undefined),
            project_attributes: this.project?.toApiObject(visited),
            _destroy: this._destroy,
        };
    }

    // NOTE: This could potentially cause infinite loops if the object graph is
    // circular.
    inAlternateTimezone(timezone: string): VendorLink {
        const clone = Object.create(this) as VendorLink;

        for (const key of Object.keys(this)) {
            if (this[key] instanceof dayjs) {
                // @ts-expect-error: Typescript thinks that this is not a dayjs object even though it is checked on the line before
                clone[key] = this[key].tz(timezone);
            } else if (Array.isArray(this[key])) {
                clone[key] = this[key].map((item) =>
                    item.inAlternateTimezone ? item.inAlternateTimezone(timezone) : item
                );
            } else if (this[key] && this[key].inAlternateTimezone) {
                clone[key] = this[key].inAlternateTimezone(timezone);
            }
        }

        return clone;
    }
}
